import { Button, Container } from "@mui/material";
import Card from "../../components/TenantCommunityInbox/Card";
import ViewList from "../../components/Templates/ViewList";
import useTenantCommunityInboxContainer from "../../containers/TenantCommunityInbox/useTenantCommunityInboxContainer";
import { useContent } from "../../content/useContent";
import { Routes } from "../../routes/Routes";
import Inbox from "./Inbox";

import Layout from "../../components/Layout";
import Title from "../../components/Title";

const classes = {
  center: {
    pt: 10,
    pb: 4,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    minHeight: "100vh",
  },
};

const TenantCommunityInbox = () => {
  const { pageLoading, page, handleChangePage, rowsPerPage, loading, rows, handleCreate } =
    useTenantCommunityInboxContainer();

  const { tenantCommunityInbox: content } = useContent().pages;

  return (
    <Layout>
      <Container sx={classes.center}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <Title title={content.tenantCommunityInbox} />
            <p>
              {content.subtitle}
            </p>
          </div>
          <Button variant="contained" onClick={() => {handleCreate()}}>
            Create
          </Button>
        </div>
        <Inbox rows={rows} />
      </Container>
    </Layout>
  );
};

export default TenantCommunityInbox;
